import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-back",
  "use": "icon-nav-back-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-nav-back\"><path d=\"M13 7.5H4.9l2.2-2.1-.7-.8L3 8l3.4 3.4.7-.8-2.2-2.1H13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol